import React from 'react';
import { Image, Text, View } from 'react-native-web';
import {
  getImageByKey,
  img_android_back,
  img_check,
  img_close,
  img_icon_add_circle,
  img_ios_back,
} from '../../../utils/ImagesManagementUtils';
import { Android, bank_logo } from '../../../utils/DictionaryManagementUtils';
import { getMediumFont } from '../../../utils/Utils';

//= ========================================================================

const PhoneHeadLine = ({
  globJSON,
  simPlatform,
  headlineText,
  isMenu,
  hideArrow,
  hideTitle,
  hideCloseButton,
  withCheckIconOnTop,
  withOutPadding,
  withGrayCircle,
}) => {
  const { colors } = globJSON.configurations.theme;
  const myStyles = {
    column: {
      flexDirection: 'column',
      paddingTop: 3,
    },
    upBarContainer: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginBottom: isMenu || withOutPadding ? 0 : 10,
      paddingHorizontal: 7,
    },
    backImage: {
      width: 14,
      height: 14,
      alignSelf: 'center',
      tintColor: colors.tertiary_icons_color,
    },
    bankLogo: {
      width: 70,
      height: 17.5,
      borderRadius: 2.3,
      backgroundColor: 'rgba(0, 26, 47, 0.02)',
    },
    headLine: {
      fontFamily: `${getMediumFont(globJSON, simPlatform)}`,
      fontSize: 12,
      color: colors.primary_font_color,
      textAlign: 'center',
      paddingTop: 3,
    },
    closeImage: {
      alignSelf: 'center',
      width: 22,
      height: 22,
      tintColor: colors.tertiary_icons_color,
    },
    circleStyle: {
      alignSelf: 'center',
      width: 18,
      height: 18,
      tintColor: colors.tertiary_icons_color,
    },
  };

  return (
    <View style={myStyles.upBarContainer}>
      {isMenu
        && (
        <Image
          fadeDuration={0}
          style={myStyles.bankLogo}
          source={getImageByKey(globJSON.configurations.services.menu.bank_logo, bank_logo)}
        />
        )}
      {!hideArrow
        && (
        <Image
          fadeDuration={0}
          style={myStyles.backImage}
          source={simPlatform === Android ? img_android_back : img_ios_back}
        />
        )}
      {!hideTitle
        && (<Text style={myStyles.headLine}>{headlineText}</Text>)}
      {!hideCloseButton ? (
        <Image
          fadeDuration={0}
          style={myStyles.closeImage}
          source={withCheckIconOnTop ? img_check : img_close}
        />
      ) : withGrayCircle ? (
        <Image
          fadeDuration={0}
          style={myStyles.circleStyle}
          source={img_icon_add_circle}
        />
      )
        : <image />}
    </View>
  );
};
export default PhoneHeadLine;
